import lazyWithRetry from 'core/system/lazyWithRetry'

import BorrowerRoutes from './BorrowerRoutes'
import withSuspense from './withSuspense'

const LazyAgentRoutes = lazyWithRetry(() => import('app/routes/AgentRoutes'))

const AgentRoutes = withSuspense(LazyAgentRoutes)

export { AgentRoutes, BorrowerRoutes }
